import { Card } from '@tribeplatform/react-ui-kit/Card';
export const CardBlock = Card;
//# sourceMappingURL=Block.js.map